var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.94033 34.1665C8.224 34.1665 7.61044 33.9111 7.09966 33.4003C6.58889 32.8896 6.3335 32.276 6.3335 31.5597V8.44009C6.3335 7.72375 6.58889 7.1102 7.09966 6.59942C7.61044 6.08864 8.224 5.83325 8.94033 5.83325H32.0599C32.7762 5.83325 33.3898 6.08864 33.9006 6.59942C34.4114 7.1102 34.6667 7.72375 34.6667 8.44009V31.5597C34.6667 32.276 34.4114 32.8896 33.9006 33.4003C33.3898 33.9111 32.7762 34.1665 32.0599 34.1665H8.94033ZM20.4993 27.7264C21.5967 27.7264 22.5891 27.4105 23.4766 26.7788C24.3641 26.147 25.0479 25.3311 25.5279 24.3311H32.5728V8.44009C32.5728 8.2905 32.5247 8.16763 32.4285 8.07146C32.3324 7.9753 32.2095 7.92721 32.0599 7.92721H8.94033C8.79075 7.92721 8.66787 7.9753 8.5717 8.07146C8.47554 8.16763 8.42745 8.2905 8.42745 8.44009V24.3311H15.4723C15.9524 25.3311 16.6359 26.147 17.5229 26.7788C18.4098 27.4105 19.402 27.7264 20.4993 27.7264Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.e1fd7b4d86c28fab80e0ec4c5ffbecfb.svg";
export { ForwardRef as ReactComponent };